(function () {
  'use strict';

  function getSectionSettings() {
    var sectionData = document.querySelector('[data-section-type="static-product"][data-section-data]');
    if (!sectionData) {
      return { cart_redirection: false, money_format: '' };
    }
    try {
      var data = JSON.parse(sectionData.textContent);
      return {
        cart_redirection: !!(data.settings && data.settings.cart_redirection),
        money_format: (data.settings && data.settings.money_format) || '',
      };
    } catch (e) {
      return { cart_redirection: false, money_format: '' };
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-complementary-atc]');
    if (!btn || btn.disabled) return;

    var root = btn.closest('[data-complementary-products]');
    if (!root) return;

    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    if (typeof window.AddToCartFlyout !== 'function') {
      console.warn('AddToCartFlyout is not available yet.');
      return;
    }

    var settings = getSectionSettings();
    var formData = [
      { name: 'id', value: variantId },
      { name: 'quantity', value: '1' },
    ];

    new window.AddToCartFlyout(formData, {
      atcButton: btn,
      settings: {
        moneyFormat: settings.money_format,
        cartRedirection: settings.cart_redirection,
      },
    });
  });
})();
